import { Button, Card, Collapse, Empty, Skeleton } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ContentCustom, PageHeaderCustom } from '../../../components';
import { useDetailsCollapse } from './utils/useDetailsCollapse';
import { useAuthContext } from '../../../contexts/AuthContext';
import { useErrorMessage } from '../../../utils/errorMessage';

export const ShowMyAnimals = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, dispatchAPI } = useAuthContext();
  const [owner, setOwner] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { petCollapse } = useDetailsCollapse(
    owner?.animals || [],
    t,
    setRefresh
  );
  const { message } = useErrorMessage();

  const getOwner = async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/owners?email=${encodeURIComponent(
          user?.email || ''
        )}&populate=animals,animals.animal_photo`
      });

      // The photos are streamed by the browser from their id (see
      // useDetailsCollapse): no more one download per photo through the API
      // client and its timeout, and no photo of an archived animal.
      const [ownerData] = data || [];
      setOwner(
        ownerData && {
          ...ownerData,
          animals: (ownerData.animals || []).filter(
            (animal) => !animal.is_archived
          )
        }
      );
    } catch (e) {
      message(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await getOwner();
    })();
  }, [refresh]);

  return (
    <>
      <PageHeaderCustom
        withoutBreadCrumb
        title={t('owners.users_shows.title.my_pets')}
        extra={
          <Button
            type="primary"
            onClick={() => navigate(`/my-pets/create/${owner?._id}`)}
          >
            <PlusOutlined />
            {t('owners.users_shows.buttons.add_animal')}
          </Button>
        }
      />
      <ContentCustom transparent>
        <Skeleton loading={isLoading} active>
          {petCollapse.length ? (
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              size="large"
              items={petCollapse}
              className="pet-collapse"
              expandIconPosition="end"
            />
          ) : (
            <Card>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t('owners.users_shows.messages.no_animal')}
                style={{ padding: '32px 0' }}
              >
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => navigate(`/my-pets/create/${owner?._id}`)}
                >
                  {t('owners.users_shows.buttons.add_animal')}
                </Button>
              </Empty>
            </Card>
          )}
        </Skeleton>
      </ContentCustom>
    </>
  );
};
